import { createSlice } from '@reduxjs/toolkit';
import { getStudyMarkingsApi } from '../../../rtk-apis/reports/getStudyMarkingsApi';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const getStudyMarkingSlice = createSlice({
  name: 'getStudyMarkingSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getStudyMarkingsApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getStudyMarkingsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.msg = action?.payload?.msg;
        state.result = action?.payload;
      })
      .addCase(getStudyMarkingsApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = action?.payload as string;
        state.result = (action?.payload as string) || '';
      });
  },
});

export const { clearState } = getStudyMarkingSlice.actions;
export default getStudyMarkingSlice.reducer;
